import React, { useCallback } from 'react';
// import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import BuyButton from '@wix/da-ds/pkg/Buttons/BuyButton';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import { pushAdoptsSellerModal } from '../../../Modals/redux/actionCreators';
import { getHasBuyItNow, getAllowOffers } from '../../helpers';
import s from './AdoptableSeller.scss';
export const AdoptableSeller = ({ deviation , className  })=>{
    const dispatch = useDispatch();
    // const { t } = useTranslation();
    const openModal = useCallback(()=>{
        dispatch(pushAdoptsSellerModal(deviation, 'offer'));
    }, [
        deviation,
        dispatch
    ]);
    const allowOffers = getAllowOffers(deviation);
    const hasBuyItNow = getHasBuyItNow(deviation);
    return /*#__PURE__*/ React.createElement(ActionBarItemWrapper, {
        className: className
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['status']
    }, allowOffers && !hasBuyItNow && /*#__PURE__*/ React.createElement("span", null, "Best offer"), !allowOffers && hasBuyItNow && /*#__PURE__*/ React.createElement("span", null, "Adopt for $", Math.round(Math.random() * 100)), allowOffers && hasBuyItNow && /*#__PURE__*/ React.createElement("div", null, "Adopt for $", Math.round(Math.random() * 100), ' ', /*#__PURE__*/ React.createElement("span", {
        className: s['subscript']
    }, "Or best offer"))), /*#__PURE__*/ React.createElement(BuyButton, {
        variant: 'outline',
        size: 'medium',
        rounded: true,
        onClick: openModal,
        className: s['offer-button']
    }, "Edit Sale"), allowOffers && /*#__PURE__*/ React.createElement(BuyButton, {
        variant: 'outline',
        size: 'medium',
        rounded: true,
        onClick: openModal
    }, "View Offers"));
};
AdoptableSeller.displayName = 'AdoptableSeller';
export default AdoptableSeller;
